import Vue from 'vue'

export default {
  getCredits() {
    return Vue.http.get('sms/credits').then(res => res.body)
  },
  getSMSBundles(params) {
    return Vue.http.get(`sms/bundles`, {params}).then(res => res.body)
  }
}
